import React from 'react';
import { Mail, Users, Target, TrendingUp, Award, Clock, MapPin, Package, CheckCircle, Briefcase, GraduationCap, Zap, FileText, Download, MessageSquare } from 'lucide-react';
export function SmartStartPage() {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-1364">
      <main className="flex-grow pt-20" data-id="element-1365">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 py-8" data-id="element-1366">
          <div className="max-w-6xl mx-auto" data-id="element-1367">
            {/* Hero */}
            <section className="mb-12" data-id="element-1368">
              <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-gray-900 mb-4" data-id="element-1369">
                SmartStart Onboarding Bundle
              </h1>
              <p className="text-2xl md:text-3xl font-semibold text-blue-600 mb-6" data-id="element-1370">
                Onboard Smarter. Equip Early. Grow Faster.
              </p>

              <div className="rounded-2xl overflow-hidden mb-6 shadow-xl" data-id="element-1371">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/goAyKf2esTbxcWp4kZ6DeP/IMG_20251023_125626.jpg" alt="SmartStart Onboarding Bundle" className="w-full h-auto object-cover hover:scale-105 transition-transform duration-500" data-id="element-1372" />
              </div>
            </section>

            {/* About */}
            <section className="mb-12" data-id="element-1373">
              <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-1374">
                About the Bundle
              </h2>
              <div className="prose prose-lg max-w-none" data-id="element-1375">
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-1376">
                  The SmartStart Onboarding Bundle by SkillzHQ Academy is a
                  ready-to-go, 3-in-1 training solution designed for startups,
                  corporates, NGOs, and HR teams looking to onboard new talent
                  quickly and effectively.
                </p>
                <p className="text-gray-700 leading-relaxed" data-id="element-1377">
                  Whether you're welcoming fresh interns or scaling your team,
                  this bundle ensures your hires are job-ready, digitally
                  confident, and leadership-aware from Day One. With hands-on,
                  self-paced learning and practical, real-world content,
                  SmartStart cuts down onboarding time while boosting
                  performance and alignment across your teams.
                </p>
              </div>
            </section>

            {/* Bundle Format */}
            <section className="mb-12" data-id="element-1378">
              <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-1379">
                Bundle Format
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1380">
                <div className="bg-white rounded-xl p-6 border-2 border-blue-100" data-id="element-1381">
                  <Clock className="w-8 h-8 text-blue-600 mb-4" data-id="element-1382" />
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1383">
                    Completion Time
                  </h3>
                  <p className="text-gray-700" data-id="element-1384">
                    Flexible, designed for 2–3 weeks onboarding cycles
                  </p>
                </div>
                <div className="bg-white rounded-xl p-6 border-2 border-green-100" data-id="element-1385">
                  <MapPin className="w-8 h-8 text-green-600 mb-4" data-id="element-1386" />
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1387">
                    Delivery Mode
                  </h3>
                  <p className="text-gray-700" data-id="element-1388">Virtual (100% online)</p>
                </div>
                <div className="bg-white rounded-xl p-6 border-2 border-blue-100" data-id="element-1389">
                  <Package className="w-8 h-8 text-blue-600 mb-4" data-id="element-1390" />
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1391">
                    Course Format
                  </h3>
                  <p className="text-gray-700" data-id="element-1392">Self-paced, cohort-friendly</p>
                </div>
              </div>
            </section>

            {/* What's Inside */}
            <section className="mb-12" data-id="element-1393">
              <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-1394">
                What's Inside the Bundle
              </h2>
              <p className="text-gray-700 mb-6" data-id="element-1395">
                The SmartStart Onboarding Bundle includes three essential
                SkillzHQ courses:
              </p>

              <div className="space-y-6" data-id="element-1396">
                <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 border-2 border-blue-100" data-id="element-1397">
                  <div className="flex items-start gap-4" data-id="element-1398">
                    <div className="flex-shrink-0 w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center" data-id="element-1399">
                      <Briefcase className="w-6 h-6 text-white" data-id="element-1400" />
                    </div>
                    <div data-id="element-1401">
                      <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-1402">
                        Employability Course
                      </h3>
                      <p className="text-gray-700 leading-relaxed" data-id="element-1403">
                        Workplace essentials for communication, professionalism,
                        collaboration, and teamwork. Prepares new hires to
                        integrate smoothly into your organizational culture.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-green-50 to-white rounded-2xl p-8 border-2 border-green-100" data-id="element-1404">
                  <div className="flex items-start gap-4" data-id="element-1405">
                    <div className="flex-shrink-0 w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center" data-id="element-1406">
                      <Zap className="w-6 h-6 text-white" data-id="element-1407" />
                    </div>
                    <div data-id="element-1408">
                      <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-1409">
                        Digital Readiness Course
                      </h3>
                      <p className="text-gray-700 leading-relaxed" data-id="element-1410">
                        Learn how to thrive in a digital-first work culture —
                        remote tools, email etiquette, online safety, and file
                        handling. Essential for modern workplace productivity.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 border-2 border-blue-100" data-id="element-1411">
                  <div className="flex items-start gap-4" data-id="element-1412">
                    <div className="flex-shrink-0 w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center" data-id="element-1413">
                      <Award className="w-6 h-6 text-white" data-id="element-1414" />
                    </div>
                    <div data-id="element-1415">
                      <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-1416">
                        Leadership Course
                      </h3>
                      <p className="text-gray-700 leading-relaxed" data-id="element-1417">
                        Nurtures decision-making, initiative, ownership, and
                        emotional intelligence in early-career professionals.
                        Builds future leaders from day one.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Target Audience */}
            <section className="mb-12" data-id="element-1418">
              <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-1419">
                Perfect For
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1420">
                {[{
                icon: Briefcase,
                text: 'Startups onboarding interns or entry-level hires'
              }, {
                icon: Users,
                text: 'Corporates running graduate trainee or contract staff programs'
              }, {
                icon: Target,
                text: 'NGOs and development organizations conducting team orientation'
              }, {
                icon: GraduationCap,
                text: 'HR departments needing a plug-and-play onboarding curriculum'
              }].map((item, index) => {
                const Icon = item.icon;
                return <div key={index} className="flex items-start gap-3 bg-blue-50 p-6 rounded-lg" data-id="element-1421">
                      <Icon className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" data-id="element-1422" />
                      <p className="text-gray-700 font-medium" data-id="element-1423">{item.text}</p>
                    </div>;
              })}
              </div>
            </section>

            {/* Why Choose SmartStart */}
            <section className="mb-12" data-id="element-1424">
              <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-1425">
                Why Companies Choose SmartStart
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1426">
                {['Saves HR and team leads time on repeated internal onboarding', 'Promotes consistent training quality and culture alignment', 'Improves early contribution, confidence, and collaboration', 'Builds digital fluency and leadership potential early on'].map((benefit, index) => <div key={index} className="flex items-start gap-3 bg-white p-6 rounded-xl border-2 border-green-100" data-id="element-1427">
                    <CheckCircle className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-1428" />
                    <p className="text-gray-700" data-id="element-1429">{benefit}</p>
                  </div>)}
              </div>
            </section>

            {/* Bundle Features */}
            <section className="mb-12" data-id="element-1430">
              <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-1431">
                Bundle Features
              </h2>
              <div className="bg-gradient-to-br from-blue-50 to-green-50 rounded-2xl p-8" data-id="element-1432">
                <div className="space-y-4" data-id="element-1433">
                  {['Structured, self-paced courses (3 total)', 'Certificate of Completion for each course', 'Optional access to an Onboarding Tracker Dashboard', 'Bulk pricing and customization available for organizations'].map((feature, index) => <div key={index} className="flex items-start gap-3" data-id="element-1434">
                      <CheckCircle className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" data-id="element-1435" />
                      <p className="text-gray-700 text-lg" data-id="element-1436">{feature}</p>
                    </div>)}
                </div>
              </div>
            </section>

            {/* CTA Section */}
            <section className="mb-12" data-id="element-1437">
              <div className="bg-gradient-to-br from-blue-600 to-green-600 rounded-3xl p-12 text-center" data-id="element-1438">
                <h2 className="text-4xl font-bold text-white mb-6" data-id="element-1439">
                  Ready to Get Started?
                </h2>
                <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto" data-id="element-1440">
                  Transform your onboarding process and set your team up for
                  success from day one
                </p>

                <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1441">
                  <a href="mailto:myskillzhq@gmail.com?subject=SmartStart Bundle - Request Invoice" className="inline-flex items-center justify-center gap-2 bg-white text-blue-600 font-semibold py-4 px-8 rounded-full hover:bg-gray-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 transform" data-id="element-1442">
                    <FileText className="w-5 h-5" data-id="element-1443" />
                    Request Invoice
                  </a>
                  <a href="mailto:myskillzhq@gmail.com?subject=SmartStart Bundle - Course Outline" className="inline-flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm text-white border-2 border-white font-semibold py-4 px-8 rounded-full hover:bg-white/20 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 transform" data-id="element-1444">
                    <Download className="w-5 h-5" data-id="element-1445" />
                    Download Outline
                  </a>
                  <a href="mailto:myskillzhq@gmail.com?subject=SmartStart Bundle - Inquiry" className="inline-flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm text-white border-2 border-white font-semibold py-4 px-8 rounded-full hover:bg-white/20 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 transform" data-id="element-1446">
                    <MessageSquare className="w-5 h-5" data-id="element-1447" />
                    Talk to Our Team
                  </a>
                </div>
              </div>
            </section>

            {/* Contact Info */}
            <section className="mb-12" data-id="element-1448">
              <div className="bg-green-50 rounded-2xl p-8 border border-green-200" data-id="element-1449">
                <div className="flex items-start gap-4" data-id="element-1450">
                  <Mail className="w-8 h-8 text-green-600 flex-shrink-0" data-id="element-1451" />
                  <div data-id="element-1452">
                    <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-1453">
                      Get Custom Pricing
                    </h3>
                    <p className="text-gray-700 mb-4" data-id="element-1454">
                      Bulk pricing and customization options are available for
                      organizations. Contact us to discuss your specific needs
                      and get a tailored quote.
                    </p>
                    <a href="mailto:myskillzhq@gmail.com" className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 font-semibold transition-colors duration-200" data-id="element-1455">
                      <Mail className="w-5 h-5" data-id="element-1456" />
                      myskillzhq@gmail.com
                    </a>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>
    </div>;
}